/* NeuroDesign Shop: reveal motion, cart buttons, scholarship gift add-on */
(function () {
  function reveal(root) {
    var els = (root || document).querySelectorAll('.nd-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  function openCart() {
    var drawer = document.querySelector('theme-drawer#cart-drawer');
    if (window.Shopify && Shopify.actions && Shopify.actions.openCart) { Shopify.actions.openCart(); return; }
    if (drawer && drawer.open) { drawer.open(); return; }
    window.location.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
  }

  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-ndc-cart-count]').forEach(function (el) {
        el.textContent = c.item_count; el.setAttribute('data-count', c.item_count);
      });
      document.querySelectorAll('[data-ndc-cart]').forEach(function (el) { el.setAttribute('aria-label', 'Cart, ' + c.item_count + ' items'); });
    }).catch(function () {});
  }

  function updateCart(lines) {
    if (window.Shopify && Shopify.actions && Shopify.actions.updateCart) {
      return Shopify.actions.updateCart({ lines: lines }).then(function (res) { refreshCount(); return res; });
    }
    var adds = lines.filter(function (l) { return !l.id; }).map(function (l) { return { id: Number(String(l.merchandiseId).split('/').pop()), quantity: l.quantity }; });
    var changes = lines.filter(function (l) { return l.id; });
    var p = Promise.resolve();
    changes.forEach(function (l) {
      p = p.then(function () { return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: l.id, quantity: l.quantity }) }); });
    });
    if (adds.length) p = p.then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: adds }) }); });
    return p.then(function () { window.location.href = '/cart'; });
  }

  document.addEventListener('click', function (e) {
    var cartBtn = e.target.closest('[data-ndc-cart]');
    if (cartBtn && document.querySelector('theme-drawer#cart-drawer')) { e.preventDefault(); openCart(); return; }

    var pill = e.target.closest('[data-ndc-gift-variant]');
    if (pill) {
      e.preventDefault();
      var wrap = pill.closest('.ndc-gift');
      var existing = wrap.getAttribute('data-existing-key');
      var lines = [];
      if (existing) lines.push({ id: existing, quantity: 0 });
      if (pill.getAttribute('aria-pressed') !== 'true') lines.push({ merchandiseId: 'gid://shopify/ProductVariant/' + pill.getAttribute('data-ndc-gift-variant'), quantity: 1 });
      wrap.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
      updateCart(lines).catch(function () { wrap.querySelectorAll('button').forEach(function (b) { b.disabled = false; }); });
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ndc-add]');
    if (!form || !(window.Shopify && Shopify.actions && Shopify.actions.updateCart)) return;
    e.preventDefault();
    var input = form.querySelector('[name="id"]:checked') || form.querySelector('select[name="id"]') || form.querySelector('input[name="id"]');
    if (!input || !input.value) return;
    var btn = form.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
    updateCart([{ merchandiseId: 'gid://shopify/ProductVariant/' + input.value, quantity: 1 }])
      .then(function () { openCart(); })
      .catch(function () { form.removeAttribute('data-ndc-add'); form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  document.addEventListener('shopify:cart:lines-update', function () { setTimeout(refreshCount, 900); });
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
  if (document.readyState !== 'loading') reveal(); else document.addEventListener('DOMContentLoaded', function () { reveal(); });
  window.addEventListener('pageshow', refreshCount);
})();
